export const MOBILE_BREAK = 700;
export const TABLET_BREAK = 950;